import React, {FC} from 'react';
import {Link} from 'react-router-dom';

import {
  BetData,
  EventStatus,
  MatchInfo,
  MatchLiveData,
  MatchScorers,
  PeriodScore,
  Sport,
} from 'utils/types';

import WidgetBet from '../WidgetBet';
import './styles.scss';

import sprite from '../../../assets/svg/match_timeline_iconsprite.svg';
import teamLogoFallback from '../../../assets/img/team-logo-placeholder.png'; // TODO: svg and colorize

// BIQ: split file

const getFormattedDate = (date: Date): string => {
  return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}.${date.getFullYear()}`;
};

const getFormattedTime = (date: Date): string => {
  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;
};

const scorersPanel = (scorers: MatchScorers) =>
  scorers &&
  (('home' in scorers && !!scorers.home.length) ||
    ('away' in scorers && !!scorers.away.length)) && (
    <div className="HeaderInfo__scorers">
      {'home' in scorers && (
        <div className="HeaderInfo__scorersList">
          {scorers.home.map(({name, goals, card}) => (
            <p key={name} className="HeaderInfo__scorer  HeaderInfo__scorer--home">
              {`${name} ${goals?.map(min => `${min}'`).join(', ')}`}
              {card && (
                <svg className="HeaderInfo__scorerCard">
                  <use href={`${sprite}#${card}`} />
                </svg>
              )}
            </p>
          ))}
        </div>
      )}
      {'away' in scorers && (
        <div className="HeaderInfo__scorersList">
          {scorers.away.map(({name, goals, card}) => (
            <p key={name} className="HeaderInfo__scorer HeaderInfo__scorer--away">
              {`${name} ${goals?.map(min => `${min}'`).join(', ')}`}
              {card && (
                <svg className="HeaderInfo__scorerCard">
                  <use href={`${sprite}#${card}`} />
                </svg>
              )}
            </p>
          ))}
        </div>
      )}
    </div>
  );

const periodScoresPanel = (periodScores: PeriodScore[]) =>
  periodScores &&
  periodScores.length && (
    <div className="HeaderInfo__periodScores">
      {periodScores.map(
        ps =>
          ps.homeScore !== undefined &&
          ps.awayScore !== undefined && (
            <>
              <h4 className="HeaderInfo__periodScore">
                {ps.periodNumber === 'Π' ? 'ΠΕΝΑΛΤΙ' : `ΠΕΡΙΟΔΟΣ ${ps.periodNumber}`}
              </h4>
              <p className="HeaderInfo__periodScore">{`${ps.homeScore} : ${ps.awayScore}`}</p>
            </>
          )
      )}
    </div>
  );

interface Props {
  matchInfo: MatchInfo;
  scorers: MatchScorers;
  liveData: MatchLiveData;
  betData: BetData;
  isBreakpointLG: boolean;
  isBreakpointXL: boolean;
}

const HeaderInfo: FC<Props> = ({
  matchInfo: {sport, competition, grouping, date, teams, location},
  scorers,
  liveData: {scores, status, matchStatus, minute, stoppageTime, broadcastUrl, periodScores},
  betData,
  isBreakpointLG,
  isBreakpointXL,
}: Props) => (
  <section className={`HeaderInfo HeaderInfo--${sport.toLowerCase()}`}>
    <div className="HeaderInfo__matchInfo">
      <span className="HeaderInfo__matchDate">{`${getFormattedDate(date)}${
        isBreakpointLG ? ` - ${getFormattedTime(date)}` : ''
      }`}</span>
      <span className="HeaderInfo__competition">
        {competition}
        {grouping ? (
          <>
            <br />
            {grouping}
          </>
        ) : null}
      </span>
      <div className="HeaderInfo__team">
        <img
          src={teams.home.imageUrl || teamLogoFallback}
          className="HeaderInfo__teamLogo"
          alt={teams.home.name}
        />
        <span className="HeaderInfo__teamName">
          {isBreakpointLG ? teams.home.name : teams.home.shortName}
        </span>
      </div>
      <span className="HeaderInfo__score HeaderInfo__score--home">{scores.home ?? '-'}</span>
      <span className="HeaderInfo__score HeaderInfo__score--separator">:</span>
      <span className="HeaderInfo__score HeaderInfo__score--away">{scores.away ?? '-'}</span>
      <div className="HeaderInfo__team">
        <img
          src={teams.away.imageUrl || teamLogoFallback}
          className="HeaderInfo__teamLogo"
          alt={teams.away.name}
        />
        <span className="HeaderInfo__teamName">
          {isBreakpointLG ? teams.away.name : teams.away.shortName}
        </span>
      </div>
      {
        /* eslint-disable no-nested-ternary */
        status === EventStatus.NOT_STARTED ? (
          !isBreakpointLG && <span className="HeaderInfo__status">{getFormattedTime(date)}</span>
        ) : status === EventStatus.LIVE &&
          ![Sport.TENNIS, Sport.VOLLEYBALL].includes(sport) &&
          matchStatus !== 'ΗΜΙ' ? (
          <>
            <span className="HeaderInfo__status">{`${minute}'${
              stoppageTime ? ` + ${stoppageTime}` : ''
            }`}</span>
            {![Sport.SOCCER, Sport.HANDBALL].includes(sport) && periodScoresPanel(periodScores)}
          </>
        ) : (
          <>
            <span className="HeaderInfo__status">{matchStatus}</span>
            {![Sport.SOCCER, Sport.HANDBALL].includes(sport) && periodScoresPanel(periodScores)}
          </>
        )
      }
    </div>
    {[Sport.SOCCER, Sport.HANDBALL].includes(sport) && scorersPanel(scorers)}
    <div className="HeaderInfo__location">{location}</div>
    {/* isBreakpointXL ? null : (
      <WidgetBet className="HeaderInfo__bet" collapsible {...{isBreakpointXL, betData}} />
    ) */}
    {broadcastUrl ? (
      <Link
        to={broadcastUrl}
        target="_blank"
        rel="external noopener noreferrer"
        className="HeaderInfo__liveBroadcast"
      >
        ΖΩΝΤΑΝΗ ΜΕΤΑΔΟΣΗ
      </Link>
    ) : null}
  </section>
);

export default HeaderInfo;
